import React from 'react';
import { FEDERAL_AGENCIES } from '../../constants/api';
import { useApiAutocomplete } from '../../hooks/useApiAutocomplete';
import { application } from '../../services/application';
import { formatToTitleCase } from '../../utils/helpers';
import Autocomplete from '../common/Inputs/Autocomplete';

export const FederalAgencyAutocomplete = (props) => {
  const { onChange, value, multi, labelKey = 'value', label, ...rest } = props;

  const { options, loading, handleValueChange, handleInputChange, filterOptions } = useApiAutocomplete({
    labelKey,
    onChange: React.useCallback((val) => onChange && onChange(val), [onChange]),
    getOptionList: (params) => application.call(FEDERAL_AGENCIES.GET_LIST_AUTOCOMPLETE, { ...params, type: 'AGENCY' }),
  });

  const validateValueArray = () => {
    if (Array.isArray(value)) {
      return value;
    } else {
      return [];
    }
  }


  return (
    <Autocomplete
      name="federal-agency"
      options={options}
      label={label}
      labelKey={labelKey}
      loading={loading}
      value={validateValueArray()}
      filterOptions={filterOptions}
      onChange={handleValueChange}
      multiple={multi}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      freeSolo
      formatLabelCB={formatToTitleCase}
      onInputChange={handleInputChange}
      {...rest}
    />
  );
};
